import { render, staticRenderFns } from "./collectorStatistics.vue?vue&type=template&id=2ceffdd7&scoped=true"
import script from "./collectorStatistics.vue?vue&type=script&lang=js"
export * from "./collectorStatistics.vue?vue&type=script&lang=js"
import style0 from "./collectorStatistics.vue?vue&type=style&index=0&id=2ceffdd7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceffdd7",
  null
  
)

export default component.exports